import { render, staticRenderFns } from "./HeaderMore.vue?vue&type=template&id=ddbfae20&scoped=true&"
import script from "./HeaderMore.vue?vue&type=script&lang=js&"
export * from "./HeaderMore.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMore.vue?vue&type=style&index=0&id=ddbfae20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbfae20",
  null
  
)

export default component.exports